module.exports = __webpack_public_path__ + "components/flag/static/square/pg-6cdc667b9647b53e9c50c86da3b0d8f7.svg";